import $ from "jquery";
import Cookies from "js-cookie";

/**
 * Functions to handle cookie banner
 */
window.setCookieAccepted = function () {
  let date = new Date(new Date().getTime() + 31536000000); // 31536000000 = 1*365*24*60 * 60 * 1000); // time in ms - 1v
  Cookies.set("cookieAccepted", "true", { expires: date });
  console.log("Cookie expires ", date);
  if (cookieAccepted() === false) {
    console.log("Cookie not accepted");
  } else {
    console.log("Cookie Accepted");
    $(".cookiesection").fadeOut(function () {
      $("body").css("margin-top", "0");
    });
  }
};

window.clickCloseCookie = function () {
  setCookieAccepted();
};

window.cookieAccepted = function () {
  return Cookies.get("cookieAccepted") ? true : false;
};
